module.exports = __webpack_public_path__ + "img/service-nongmaojianguan2.8e574f4f.svg";